/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

/**
 * Returns the value for display, using an em dash for missing or empty values.
 *
 * @param value - An optional value, such as a field from the API.
 * @returns The value, or `—` when it is null, undefined, or empty.
 *
 * @example
 * valueOrDash(appType.description) // "Mobile Banking"
 * valueOrDash(undefined) // "—"
 */
export function valueOrDash(value: string | null | undefined): string {
    return value || "—"
}
